module.exports = __webpack_public_path__ + "img/craftBannerWintergardenMobile.60efcb8.webp";